import MyAccountView from "./MyAccountView"

export default MyAccountView;